<template>
  <b-modal
    id="details-sales-view"
    no-enforce-focus
    title="Detalhes do Banner Sales"
    header-bg-variant="dark"
    header-close-variant="light"
    title-class="text-light font-18"
    hide-footer
  >
    <div class="grid-web">
      <b-col cols="12" style="display: flex; width: 100%; justify-content: center;">
        <div v-if="payload.image_url" class="file-inner">
          <img style="border-radius: 5px; width: 100%;" :src="payload.image_url" alt="Banner Sales" />
        </div>
        <div v-else class="file-inner">
          <span>Sem imagem</span>
        </div>
      </b-col>
      <div class="row">
        <div class="col-12">
          <b-form-group label="Link de redirecionamento" label-for="sales-banner-view-link">
            <b-form-input id="sales-banner-view-link" :value="payload.link || '-'" disabled></b-form-input>
          </b-form-group>
        </div>
        <div class="col-12 mt-2">
          <b-form-group
            label="Ordem de exibição"
            label-for="sales-banner-view-order"
            description="Ao escolher uma posição, os demais banners são reordenados automaticamente."
          >
            <b-form-select
              id="sales-banner-view-order"
              v-model="selectedOrder"
              :options="orderOptions"
              :disabled="saving"
            ></b-form-select>
          </b-form-group>
        </div>
        <div class="col-12 mt-3 pa-2">
          <UIActionButton variant="success" :disabled="!canSave" @click="saveOrder">
            Salvar ordem
          </UIActionButton>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex'
import UIActionButton from '@components/ui-design/UIActionButton'

export default {
  components: { UIActionButton },
  props: {
    payload: {
      required: false,
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      selectedOrder: null,
      saving: false
    }
  },
  computed: {
    ...mapGetters({ salesBanners: 'getSalesBanners' }),
    orderOptions() {
      const total = this.salesBanners.length || 1
      return Array.from({ length: total }, (item, index) => index + 1)
    },
    canSave() {
      return !this.saving && this.selectedOrder != null && this.selectedOrder !== this.payload.order
    }
  },
  watch: {
    payload() {
      this.syncOrder()
    }
  },
  methods: {
    syncOrder() {
      this.selectedOrder = this.payload.order != null ? Number(this.payload.order) : null
    },
    saveOrder() {
      this.saving = true
      return this.$store.dispatch('updateSalesBannerOrder', { id: this.payload.id, order: this.selectedOrder })
        .then(() => {
          this.$bvToast.toast('a ordem do banner foi atualizada com sucesso!', {
            variant: 'success',
            title: 'Ordem atualizada!',
            autoHideDelay: 5000
          })
          this.$bvModal.hide('details-sales-view')
        })
        .catch(() => {
          this.$bvToast.toast('Não foi possível atualizar a ordem do banner.', {
            variant: 'danger',
            title: 'Erro ao atualizar',
            autoHideDelay: 5000
          })
        })
        .finally(() => { this.saving = false })
    }
  }
}
</script>

<style lang="scss" scoped>
.grid-web {
  display: grid;
  grid-template-columns: 1fr;
  gap: 40px;
}

.file-inner {
  display: flex;
  width: 100%;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
</style>
